import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import * as React from 'react';
import { DropdownStyles as S } from './Dropdown.styles';
import { FocusRing } from 'react-aria';
const Dropdown = ({ labelText, options, value, onOptionChange }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Label, { htmlFor: labelText }, labelText),
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Select, { id: labelText, name: labelText, value: value, onChange: (event) => onOptionChange(event.target.value) }, options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text))))),
        getSvgFromSystem(SystemIcon.ChevronDown)));
};
export default Dropdown;
